import React, { FunctionComponent } from "react";
import Spinner from "react-bootstrap/Spinner";
import InteractiveAnalysisLink from "../interactiveanalysis/components/interactive-analysis-link/InteractiveAnalysisLink";
import RenderWhen from "../../../../components/RenderWhen";

type RlCloudSandboxErrorProps = {
  dataError: string;
  isAnalyzing: boolean;
  displayStatus: string;
  sampleParams: {
    hash: string;
    uploadId: number;
    url: string;
  };
};

const RLCloudSandboxError: FunctionComponent<RlCloudSandboxErrorProps> = ({
  dataError,
  isAnalyzing,
  displayStatus,
  sampleParams
}) => (
  <>
    <div className="mb-10">{dataError}</div>
    <div>
      <b className="me-5">Status:</b>
      {isAnalyzing && (
        <Spinner
          animation="border"
          size="sm"
          variant="secondary"
          className="me-5"
        />
      )}
      <b>{displayStatus}</b>
      <RenderWhen condition={isAnalyzing}>
        <span className="ms-10">
          <InteractiveAnalysisLink {...sampleParams} />
        </span>
      </RenderWhen>
    </div>
  </>
);

export default RLCloudSandboxError;
